module.exports = __webpack_public_path__ + "img/photonix.aafbc0d5.jpeg";